export default __webpack_public_path__ + "static/ABCMonumentGrotesk-Medium-8970f19f424644e69f99d33706effeb0.woff2";